import React from 'react';

const CaseStudies = () => {
  const cases = [
    {
      title: 'ShopHub E-Commerce Platform',
      client: 'Retail Startup',
      challenge: 'Needed a modern e-commerce platform to compete with established players',
      solution: 'Built scalable React + Node.js platform with AI recommendations',
      results: ['150% sales increase', '45% cart conversion boost', '2.1s page load time'],
      tech: ['React', 'Node.js', 'MongoDB', 'AWS']
    },
    {
      title: 'MediCare Telemedicine System',
      client: 'Healthcare Provider',
      challenge: 'Manual patient management causing inefficiencies and care gaps',
      solution: 'Developed HIPAA-compliant telemedicine platform with patient records',
      results: ['60% time savings', '300+ daily consultations', '98% uptime'],
      tech: ['Vue.js', 'Python', 'PostgreSQL', 'AWS']
    },
    {
      title: 'FinanceTrack Analytics Dashboard',
      client: 'FinTech Firm',
      challenge: 'Real-time financial data visualization for traders',
      solution: 'Created real-time dashboard with predictive analytics',
      results: ['15ms data latency', '$2M revenue increase', '50k+ daily users'],
      tech: ['Angular', 'Java', 'MySQL', 'Redis']
    }
  ];

  return (
    <section id="case-studies">
      <div className="section-header">
        <h2 className="section-title">Case Studies</h2>
        <p className="section-subtitle">Real results from real projects that transformed businesses</p>
      </div>
      <div className="case-studies-grid">
        {cases.map((study, index) => (
          <div className="case-study-card fade-in" key={index} style={{animationDelay: `${index * 0.1}s`}}>
            <div className="case-header">
              <h3>{study.title}</h3>
              <span className="client-badge">{study.client}</span>
            </div>
            <div className="case-content">
              <div className="case-section">
                <h5>Challenge</h5>
                <p>{study.challenge}</p>
              </div>
              <div className="case-section">
                <h5>Solution</h5>
                <p>{study.solution}</p>
              </div>
              <div className="case-results">
                <h5>Results</h5>
                <ul>
                  {study.results.map((result, i) => (
                    <li key={i}>📈 {result}</li>
                  ))}
                </ul>
              </div>
              <div className="case-tech">
                {study.tech.map((t, i) => (
                  <span key={i} className="tech-tag">{t}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CaseStudies;
